<template>
    <div class="paginations-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Pagination</h3>
                </div>

                <nav aria-label="Page navigation example">
                    <ul class="pagination custom-style">
                        <li class="page-item"><a class="page-link" href="#">Previous</a></li>
                        <li class="page-item"><a class="page-link" href="#">1</a></li>
                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                        <li class="page-item"><a class="page-link" href="#">Next</a></li>
                    </ul>
                </nav>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Pagination Icon</h3>
                </div>

                <nav aria-label="Page navigation example">
                    <ul class="pagination custom-style">
                        <li class="page-item">
                            <a class="page-link" href="#" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                            </a>
                        </li>

                        <li class="page-item"><a class="page-link" href="#">1</a></li>
                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                        <li class="page-item"><a class="page-link" href="#">3</a></li>

                        <li class="page-item">
                            <a class="page-link" href="#" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Pagination Disabled And Active States</h3>
                </div>

                <nav aria-label="Page navigation example">
                    <ul class="pagination custom-style">
                        <li class="page-item disabled">
                            <a class="page-link" href="#">Previous</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link" href="#">1</a>
                        </li>
                        <li class="page-item active" aria-current="page">
                            <a class="page-link" href="#">2</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link" href="#">3</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link" href="#">Next</a>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Pagination Align Center</h3>
                </div>

                <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center custom-style">
                        <li class="page-item"><a class="page-link" href="#">Previous</a></li>
                        <li class="page-item"><a class="page-link" href="#">1</a></li>
                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                        <li class="page-item"><a class="page-link" href="#">Next</a></li>
                    </ul>
                </nav>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Pagination Align End</h3>
                </div>

                <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-end custom-style">
                        <li class="page-item"><a class="page-link" href="#">Previous</a></li>
                        <li class="page-item"><a class="page-link" href="#">1</a></li>
                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                        <li class="page-item"><a class="page-link" href="#">Next</a></li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaginationContent'
}
</script>

<style lang="scss">
.pagination {
	&.custom-style {
		.page-item {
			.page-link {
				transition: var(--transition);
				color: var(--body-color);
				&:hover {
					background-color: var(--main-color);
					color: var(--white-color);
				}
				&.active {
					background-color: var(--main-color);
					color: var(--white-color);
				}
			}
			&.active {
				.page-link  {
					background-color: var(--main-color);
					color: var(--white-color);
					border-color: var(--main-color);
				}
			}
		}
	}
}
</style>